import { Field, FieldProps } from "formik";
import React, { useState } from "react";
import styles from "./style.module.scss";
import { ReactComponent as ShowIcon } from "../../assets/eye.svg";
import { ReactComponent as HideIcon } from "../../assets/eye-crossed.svg";

interface ComponentProps {
  label: string;
  name: string;
  placeholder?: string;
  disabled?: boolean;
  type?: string;
  readOnly?: boolean;
  asterisk?: boolean;
  isRow?: boolean;
}

const Input: React.FC<ComponentProps> = (props) => {
  const {
    name,
    label,
    disabled,
    type,
    placeholder,
    readOnly,
    isRow,
  
    asterisk = false,
  } = props;
  const [isShowPassword, setIsShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setIsShowPassword((prevState) => !prevState);
  };

  const inputClassName = isRow ? styles.input : styles.inputTwo;

  return (
    <Field name={name}>
      {({ field, meta }: FieldProps) => (
        <div>
          <div className={isRow ? styles.loginContainer : ""}>
            <label className={styles.label}>
              {asterisk ? (
                <span>
                  {label}
                  <sup className={styles.asterisk}>*</sup>
                </span>
              ) : (
                label
              )}
            </label>

            <div className={styles.wrapper}>
              {type !== "textarea" ? (
                <div className={styles.inputContainer}>
                  <input
                    {...field}
                    type={isShowPassword && type === "password" ? "text" : type}
                    placeholder={placeholder}
                    disabled={disabled}
                    className={inputClassName}
                    readOnly={readOnly}
                  />
                  {type === "password" && (
                    <span
                      className={styles.showToggle}
                      onClick={togglePasswordVisibility}
                      role="button"
                      aria-label={
                        isShowPassword ? "Hide password" : "Show password"
                      }
                    >
                      {isShowPassword ? (
                        <HideIcon width="1.5rem" height="1.5rem" />
                      ) : (
                        <ShowIcon width="1.5rem" height="1.5rem" />
                      )}
                    </span>
                  )}
                </div>
              ) : (
                <textarea
                  className={styles.inputTwo}
                  {...field}
                  placeholder={placeholder}
                  rows={4}
                />
              )}

              {meta.touched && meta.error && (
                <div className={styles.error}>{meta.error}</div>
              )}
            </div>
          </div>
        </div>
      )}
    </Field>
  );
};

export default Input;
